/**
 * AI Model Usage Report (standalone page)
 *
 * Full-page route at /ai/model-usage. Same content is also embedded in
 * Settings → Profile → Subscription tab via ModelUsageReport embedded.
 */

import React from 'react';
import { ModelUsageReport } from './ModelUsageReport';

const ModelUsagePage: React.FC = () => {
  return <ModelUsageReport />;
};

export default ModelUsagePage;
